console.log("personalizer-popup-liquid.js.liquid loaded");
if (!allreaddyLoad) {

    $(function() {

        $.widget("custom.selectmenu", $.ui.selectmenu, {
            _renderItem: function(ul, item) {
                const color = item.element[0]?.label
                let li = $("<li>"), wrapper = $("<div>");
                $("<span>", {style: "background-color: " + color, "class": "ui-color-chip"}).appendTo(wrapper);
                wrapper.append(item.label);
                return li.append(wrapper).appendTo(ul);
            }
        });

        $("#backg-img-select").selectmenu({
            change: function( event, data )  {
                let backgroundImageSource = $(".Product__SlideItem img[data-original-src]").last().data("original-src");
                const nbImages = parseInt(data.item.element[0]?.title)
                let backg_value = data.item.value
                let product_modal_image = $("#customizer")
                if (backg_value === "") {
                    product_modal_image.attr("src", backgroundImageSource);
                    for (let i = 1; i <= nbImages; i++) {
                        let above_image = document.getElementById("above-img-color" + i)
                        above_image.src = ""
                        above_image.style.display = "none"
                    }
                    let color_select = document.getElementById("color-img-select");
                    color_select.value = ""
                    $("#selected_background").val("");

                } else {
                    product_modal_image.attr("src", backg_value);
                    $("#selected_background").val(backg_value);
                }
            }
        }).
        selectmenu("menuWidget").
        addClass("ui-menu-icons customicons");

        $('[id^=color-img-select-]').each(function( index ) {
            let select_index = index + 1;
            $("#color-img-select-" + select_index).selectmenu({
                change: function( event, data ) {

                    let product_modal_image = document.getElementById('customizer')
                    let color_select = document.getElementById("color-img-select-" + select_index);
                    let color_value = color_select.value;
                    const nbImages = parseInt(data.item.element[0]?.title)

                    for (let i = 0; i <= nbImages; i++) {
                        let above_image = document.getElementById("above-img-color-" + select_index + "-" + i)
                        if (color_select.selectedIndex === i) {
                            if(i > 0){
                                above_image.style.display = "inherit"
                                above_image.src = color_value
                                above_image.width = product_modal_image.clientWidth
                                above_image.height = product_modal_image.clientHeight
                            }
                            if(extra_images_array.find( x => x.key === ("above-img-color-" + select_index))){
                                let find_index = extra_images_array.findIndex( x => x.key === ("above-img-color-" + select_index))
                                if(color_value !== ""){
                                    extra_images_array[find_index] = {url: above_image.src, type: "custom_images",key:"above-img-color-" + select_index}
                                }else{
                                    extra_images_array.splice(find_index,1);
                                }
                            }else{
                                let extra = {url: above_image.src, type: "custom_images",key:"above-img-color-" + select_index}
                                extra_images_array.push(extra)
                            }
                        } else {
                            if(i > 0){
                                above_image.src = ""
                                above_image.style.display = "none"
                            }
                        }
                    }
                    console.log(extra_images_array)
                    $("#selected_images_list").val(window.btoa(JSON.stringify(extra_images_array)));

                }
            }).
            selectmenu("menuWidget").
            addClass("ui-menu-icons customicons");
        });
    });

    var allreaddyLoad = true;
    var extra_images_array = [];

    function onClickSliderImage(img, nbImages) {

        let product_modal_image = document.getElementById('customizer')

        if (img.id !== "0") {
            if ($("#overExtraImgItem" + img.id).hasClass('selected_over_image') === true) {
                for (let i = 1; i <= nbImages; i++) {
                    let above_image = document.getElementById("above-img-slider" + i)
                    if (img.id === i.toString()) {
                        above_image.src = ""
                        above_image.style.display = "none"
                    }
                }
                $("#check-icon-container" + img.id).children().first().remove()
                $("#overExtraImgItem" + img.id).removeClass('selected_over_image')
            } else {
                for (let i = 1; i <= nbImages; i++) {
                    let above_image = document.getElementById("above-img-slider" + i)
                    if (img.id === i.toString()) {
                        above_image.style.display = "inherit"
                        if (img.alt && img.alt !== "") {
                            above_image.src = img.alt
                        } else {
                            above_image.src = img.src
                        }
                        above_image.width = product_modal_image.clientWidth
                        above_image.height = product_modal_image.clientHeight
                    }
                }

                $("#overExtraImgItem" + img.id).addClass("selected_over_image");
                $("#check-icon-container" + img.id).prepend("<img src='//us.isidoreleroy.com/cdn/shop/t/35/assets/checkmark-240.png?v=164819672239214267351782717322' style='width: 20px;height: 20px;max-width:20px' onclick='onClickSliderImage(this)'>")

                let extra_images_array = []
                $('#overExtraImgWrapper').children('div').each(function (index) {
                    if ($(this).hasClass('selected_over_image') === true) {
                        let imgElement = $(this).children()[1]
                        let priceElement = $(this).children()[2]
                        let extra = {
                            url: (imgElement.alt && imgElement.alt !== "") ? imgElement.alt : imgElement.src,
                            type: "extra_images"
                        }
                        extra_images_array.push(extra)
                    }
                });
                $("#selected_images_list").val(window.btoa(JSON.stringify(extra_images_array)));
            }
        } else {
            for (let i = 1; i <= nbImages; i++) {
                let above_image = document.getElementById("above-img-slider" + i)
                if (above_image) {
                    above_image.src = ""
                    above_image.style.display = "none"
                }
            }
            $('#overExtraImgWrapper').children('div').each(function (index) {
                if (index > 0) {
                    $(this).removeClass('selected_over_image')
                    $("#check-icon-container" + index).children().remove()
                }
            });
            $("#selected_images_list").val("");
        }
    }

    function onClickBackgColorSelect(nbImages) {
        let backgroundImageSource = $(".Product__SlideItem img[data-original-src]").last().data("original-src");
        let backg_select = document.getElementById("backg-img-select");
        let backg_value = backg_select.value;
        let product_modal_image = $("#customizer")

        if (backg_value === "") {
            product_modal_image.attr("src", backgroundImageSource);
            for (let i = 1; i <= nbImages; i++) {
                let above_image = document.getElementById("above-img-color" + i)
                above_image.src = ""
                above_image.style.display = "none"
            }
            let color_select = document.getElementById("color-img-select");
            color_select.value = ""
            $("#selected_background").val("");

        } else {
            product_modal_image.attr("src", backg_value);
            $("#selected_background").val(backg_value);
        }
    }

    function onClickColorSelect(nbImages, index) {

        let product_modal_image = document.getElementById('customizer')
        let color_select = document.getElementById("color-img-select-" + index);
        let color_value = color_select.value;

        for (let i = 0; i <= nbImages; i++) {
            let above_image = document.getElementById("above-img-color-" + index + "-" + i)
            if (color_select.selectedIndex === i) {
                if(i > 0){
                    above_image.style.display = "inherit"
                    above_image.src = color_value
                    above_image.width = product_modal_image.clientWidth
                    above_image.height = product_modal_image.clientHeight
                }
                if(extra_images_array.find( x => x.key === ("above-img-color-" + index))){
                    let find_index = extra_images_array.findIndex( x => x.key === ("above-img-color-" + index))
                    if(color_value !== ""){
                        extra_images_array[find_index] = {url: above_image.src, type: "custom_images",key:"above-img-color-" + index}
                    }else{
                        extra_images_array.splice(find_index,1);
                    }
                }else{
                    let extra = {url: above_image.src, type: "custom_images",key:"above-img-color-" + index}
                    extra_images_array.push(extra)
                }
            } else {
                if(i > 0){
                    above_image.src = ""
                    above_image.style.display = "none"
                }
            }
        }
        $("#selected_images_list").val(window.btoa(JSON.stringify(extra_images_array)));
    }

    function onScrollNext() {
        var element = document.querySelector("#slider-gallery")
        element.scrollTo({
            left: element.scrollLeft + 122,
            behavior: 'smooth'
        })
    }

    function onScrollPrevious() {
        var element = document.querySelector("#slider-gallery")
        element.scrollTo({
            left: element.scrollLeft - 122,
            behavior: 'smooth'
        })
    }

 function getPriceAndCurrency() {
        if ($(".ProductMeta__Price").first().html()) {
            price = parseInt(($(".ProductMeta__Price").first().html().toString()).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1').replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1').replace(/\D/g, ''))/10;//parseInt(($(".ProductMeta__Price").first().html()).replace(/\D/g,''));
            currency = $(".ProductMeta__Price").first().html().replace(/[0-9]/g, '').replace('.', '');
            $(".ProductMeta__PriceList.Heading").html(currency + " " + price + " / sq ft")
        }
    };
    getPriceAndCurrency();
    $('.ProductForm__Variants').bind("DOMSubtreeModified", function () {
        getPriceAndCurrency();
    });


    /*$( "span.ProductForm__OptionName:contains('Dimension: ')" ).bind("DOMSubtreeModified",function(e){
       var isSurMesure = $( "span.ProductForm__OptionName:contains('Dimension: ')" ).children().first().html() == "Sur-mesure";
     if(isSurMesure && !personalizerModlIsOpen){
         $("#modal-personalizer-trigger-prouctPage").click();
     }
   });
*/


    var xRatio = 600, // 675 cmRatio = pxRation
        yRatio = 300,  // 330 cmRatio = pxRation
        xMax = {start: 600, end: 600},
        yMax = {start: 300, end: 300},//{start: 330, end: 330}
        xMin = {start: 50, end: 100},//{start: 50, end: 100}
        yMin = {start: 50, end: 100};//{start: 50, end: 100}

    var canvas_x;
    var canvas_y;

    var x_realImg = 0; //display width
    var y_realImg = 0;
    var x_baseImg = 0; // originalimg width
    var y_baseImg = 0;

    var img = $("#customizer");
    var x_wall = $("#wall-width");
    var y_wall = $("#wall-height");
    var $wall = $("#wall-width, #wall-height")

    var start_x_wall, start_y_wall;
    var isidoreImgAreaSelect = null;
    var backgroundImageSource = $(".Product__SlideItem img[data-original-src]").last().data("original-src");
    var backgroundImageList = $(".Product__SlideItem img[data-original-src]").map(function (idx, ele) {
        return $(ele).data("original-src");
    }).get()
    img.attr("src", backgroundImageSource);

    var selectionOptionColorBackground = function () {
        var varianteColor = $("span.ProductForm__OptionName").text().split("Couleur: ")[1];
        if (!varianteColor) {
            varianteColor = $("span.ProductForm__OptionName").text().split("Color: ")[1];
        }
        if (varianteColor) {
            backgroundImageList.forEach(el => {
                if (el.indexOf("__" + varianteColor + "__") != -1) {
                    backgroundImageSource = el;
                    img.attr("src", backgroundImageSource);
                }
            });
        }
    }
    selectionOptionColorBackground();

    var inputFinalText = $("#inputFinalText");
    var inputFinalImage = $("#inputFinalImage");
    img.attr("crossorigin", "anonymous");

    var pInfoEdited = false;
    initTrigger();
    var initData = function (callback) {
        selectionOptionColorBackground();
        $("<img>").attr("src", $(img).attr("src")).load(function () {
            var dataSize = this.src.replace(/^.*[\\\/]/, '').split("x");
            if (!pInfoEdited) {
                pInfoEdited = true;
                xRatio = dataSize[0];
                yRatio = dataSize[1];
                //$("#pInfo").html($("#pInfo").html().replace("600", xRatio).replace("300", yRatio)); //update info texte
                xMax.start = xMax.end = xRatio;
                yMax.start = yRatio;
                xMax.end = xRatio * 1.3;
                yMax.end = yRatio * 1.3;
            }


            x_baseImg = this.width;
            y_baseImg = this.height;

            x_realImg = parseInt(img.width());
            y_realImg = parseInt(img.height());

            x_wall.attr({"min": Math.ceil(xMin.start/2.54), "max": Math.floor(xMax.end/2.54)});
            y_wall.attr({"min": Math.ceil(yMin.start/2.54), "max": Math.floor(yMax.end/2.54)});

            if (callback)
                callback();
        });
    };
    initData();

    var ratioFromBase = function (value) {
        return Math.ceil(value * x_baseImg / x_realImg);
    }
    var ratioFromBasePercent = function () {
        return Math.ceil(100 * x_baseImg / x_realImg);
    }

    var cmToPx = function (value) {
        return (value * (x_realImg / xRatio));//Math.round(value * (x_realImg / xRatio));
    }
    var pxToCm = function (value) {
        return (value * (xRatio / x_realImg));//Math.round(value * (xRatio / x_realImg));
    }
    var resizeCanvas = function (fromRatio) {
        if (fromRatio === true && ratioChoice) {
            var ratioTmp = ratioChoice / 100;
            var target_x = canvas_x * (1 / ratioTmp);//Math.round(canvas_x* (1/ratioTmp));
            var target_y = canvas_y * (1 / ratioTmp);//Math.round(canvas_y* (1/ratioTmp));

            if (target_x > x_realImg || target_y > y_realImg) {
                ratioChoice = parseInt(ratioChoice) + 1;
                resizeCanvas(true);
            } else {
                canvas_x = target_x;
                canvas_y = target_y;
                setRatioChoiceInvert();
                updateRatioDisplay();
            }
        } else {
            ratioChoice = 100;
            if ((canvas_y / y_realImg) <= 0.66) {
                //ratioChoice = 50;
            }
            if (canvas_y >= y_realImg) {
                ratioChoice = 120;
            }
            //setRatioChoiceInvert();
            //updateRatioDisplay();
            resizeCanvas(true);
        }
    }

    var resizeY = function (value) {
        return value;
    }

    function preview(img, selection) {
        updatePreview(selection);
    }

    var updateQuantityAndPrice = function (width, height) {
        var quantity = parseInt((width * height / 1000) / 0.929);
        $("[name='quantity']").val(quantity);
        var finalPrice = parseFloat(price * quantity).toFixed(2);

        $("#custom-price").html(
            currency + " " + finalPrice
        );
    };


    var updatePreview = function (selection) {
        var width = selection.x2 - selection.x1;//ratioFromBase(selection.x2 - selection.x1);
        var height = selection.y2 - selection.y1;//ratioFromBase(selection.y2 - selection.y1);
        var top = selection.y1;//ratioFromBase(selection.y1);
        var left = selection.x1;//ratioFromBase(selection.x1);


        $(unselectDiv).off("mousedown", unselect);
        $(unselectDiv).on("mousedown", unselect);

        var widthpercentRatio = 100 + ((x_baseImg - width) / width * 100);//100 + Math.round( (x_baseImg - width) / width * 100);
        var heightpercentRatio = 100 + ((y_baseImg - height) / height * 100);//100 + Math.round( (y_baseImg - height) / height * 100);

        start_x_wall = pxToCm(left);
        start_y_wall = pxToCm(top);

        /* 
         $("#inputFinalText").val( 'Width*Height (inch): '+ 
                              x_wall.val() + '*'+  y_wall.val()+
                             '/n' +'Start X*Y (inch): ' +
                              start_x_wall + '*'+ start_y_wall+
                             'IMAGE:'+
                             'width:'+ width+'px;'+
                             'height:' + height+'px;'+
                             'background:url('+img.attr("src")+');'+
                             'background-size: '+widthpercentRatio +'% '+heightpercentRatio+'%;'+
                             'background-position: top -'+top+'px '+
                             'left -'+left+'px;'); 
         */
        var previewUrlParams = {
            x1: selection.x1,
            x2: selection.x2,
            y1: selection.y1,
            y2: selection.y2,
            width: x_realImg,
            height: y_realImg,
            ratio: $('#ratioInput').val(),
            imageUrl: img.attr("src")
        }

        var b64_preview_params = window.btoa(JSON.stringify(previewUrlParams));
        
        
        $("#inputFinalText").val("https://isidore-leroy.s3.eu-west-1.amazonaws.com/rocket_ba/je2.html?params=" + b64_preview_params);

        $("#inputTailleUs").val(" " + x_wall.val() + " x " + y_wall.val() + " (inch)");
        $("#inputTaille").val(" " + x_wall.val() * 2.54 + " x " + y_wall.val() * 2.54 + " (cm)");
        $("#inputDecalage").val(" " + start_x_wall + " x " + start_y_wall);

    };


    var x_previousValue, y_previousValue, ratioChoice_previousValue;

    var initSelector = function (fromRatio) {
        //initData(function(){
        var tmpX = x_wall.val() * 2.54;
        var tmpY = y_wall.val() * 2.54;

        if (x_previousValue && x_previousValue == tmpX &&
            y_previousValue && y_previousValue == tmpY &&
            ratioChoice_previousValue && ratioChoice_previousValue == ratioChoice) {
            return;
        } else {
            x_previousValue = tmpX;
            y_previousValue = tmpY;
        }


        // check max and min values
        if (parseInt(tmpX) > parseInt(xMax.end)) {
            tmpX = xMax.end;
            x_wall.val(xMax.end);
        }
        ;
        //if(tmpX < xMin.start){tmpX = xMin.start; x_wall.val(xMin.start)};
        if (parseInt(tmpY) > parseInt(yMax.end)) {
            tmpY = yMax.end;
            y_wall.val(yMax.end);
        }
        ;
        //if(tmpY < yMin.start){tmpY = yMin.start; y_wall.val(yMin.start)};

        // check if the minimum aera order is touch (2 m2)
        if (!tmpX || !tmpY || parseInt(tmpX) * parseInt(tmpY) < 20000) {
            $("#personalize-addcart-button").attr('disabled', 'disabled');
            $("#alert-quantity").show();
        } else {
            $("#personalize-addcart-button").removeAttr('disabled');
            $("#alert-quantity").hide();
        }
        canvas_x = cmToPx(parseInt(tmpX));
        canvas_y = cmToPx(parseInt(tmpY));

        resizeCanvas(fromRatio);

        if (canvas_x && canvas_y) {
            var xstart = (x_realImg - canvas_x) / 2;
            var ystart = (y_realImg - canvas_y) / 2;

            start_x_wall = pxToCm(xstart);
            start_y_wall = pxToCm(ystart);

            img.imgAreaSelect({
                movable: true,
                persistent: true,
                resizable: false,
                imageWidth: x_realImg,
                imageHeight: y_realImg,
                x1: xstart,
                y1: ystart,
                x2: xstart + canvas_x - 1,
                y2: ystart + canvas_y - 1,
                onSelectChange: preview
            });
            updatePreview({
                x1: xstart,
                y1: ystart,
                x2: xstart + canvas_x,
                y2: ystart + canvas_y
            });
            updateQuantityAndPrice(tmpX, tmpY);
        }

        //});
    };

    var wto;
    $wall.on("change paste keyup", initSelector);

    var clickOnCart = function () {
        ratioChoice = $('#ratioInput').val();
        window.setTimeout(function () {
            window.location.href = "/cart";
        }, 800);
    };

    $('.modal-personalizer').off("click", ".ProductForm__AddToCart", clickOnCart);
    $('.modal-personalizer').on("click", ".ProductForm__AddToCart", clickOnCart);

    var ratioChoice = null;
    //var ratioChoiceInvert = null;
    var ratioChoose = function () {
        ratioChoice = $('#ratioInput').val();
        //setRatioChoiceInvert();
        updateRatioDisplay();
        initSelector(true);
    };

    var setRatioChoiceInvert = function () {
        if (ratioChoice < 100) {
            ratioChoiceInvert = 100 + (100 - ratioChoice);
        } else if (ratioChoice > 100) {
            ratioChoiceInvert = 100 - (ratioChoice - 100);
        }
    };

    var updateRatioDisplay = function () {
        $('#ratio-display').text(ratioChoice + "%");
        $("#ratioInput").val(ratioChoice);
        $("#inputFinalRatio").val(ratioChoice);
    };

    var unselect = function () {
        $("input").blur();
    };
    var unselectDiv = ".imgareaselect-selection, .imgareaselect-border1, .imgareaselect-border2, .imgareaselect-border3, .imgareaselect-border4";


    $('#ratioInput').off('input', ratioChoose);
    $('#ratioInput').on('input', ratioChoose);

}
//# sourceURL=isidore-popup-customoizer.js